import MessageWarn from "./searchope2.vue"

const Situationall2 = {
	install(Vue) {//install方法注册全局组件
		Vue.component('Situationall2', MessageWarn)
	}
};

export default Situationall2;
